(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-banner-clean"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  function initCountdownBanner(sectionId) {
    const banner = document.getElementById('countdown-banner-' + sectionId);
    if (!banner) return;

    const startDate = banner.dataset.startDate;
    const startTime = banner.dataset.startTime || '00:00';
    const endDate = banner.dataset.endDate;
    const endTime = banner.dataset.endTime || '23:59';
    const saleState = banner.dataset.saleState;

    if (saleState === 'ended') {
      // Sale has ended, show ended message
      return;
    }

    // Parse dates and times
    let startDateTime = null;
    let endDateTime = null;

    if (startDate) {
      const [startYear, startMonth, startDay] = startDate.split('-');
      const [startHours, startMinutes] = startTime.split(':');
      startDateTime = new Date(startYear, startMonth - 1, startDay, parseInt(startHours), parseInt(startMinutes), 0, 0);
    }

    if (endDate) {
      const [endYear, endMonth, endDay] = endDate.split('-');
      const [endHours, endMinutes] = endTime.split(':');
      endDateTime = new Date(endYear, endMonth - 1, endDay, parseInt(endHours), parseInt(endMinutes), 0, 0);
    }

    const timerElements = {
      days: banner.querySelector('[data-days]'),
      hours: banner.querySelector('[data-hours]'),
      minutes: banner.querySelector('[data-minutes]'),
      seconds: banner.querySelector('[data-seconds]')
    };

    const bannerTextElement = banner.querySelector('.countdown-banner__text');
    const shopNowOverlay = banner.querySelector('.countdown-banner__shop-now-overlay');
    
    // Random animation for "shop now" text
    let shopNowTimeout = null;
    
    function showShopNow() {
      if (!shopNowOverlay) return;
      
      // Random duration between 2-4 seconds visible
      const visibleDuration = 2000 + Math.random() * 2000;
      // Random delay before next appearance between 3-8 seconds
      const nextDelay = 3000 + Math.random() * 5000;
      
      shopNowOverlay.classList.add('visible');
      
      setTimeout(function() {
        if (shopNowOverlay) {
          shopNowOverlay.classList.remove('visible');
        }
      }, visibleDuration);
      
      shopNowTimeout = setTimeout(showShopNow, visibleDuration + nextDelay);
    }
    
    // Start the random animation cycle
    if (shopNowOverlay) {
      // Initial delay before first appearance (1-4 seconds)
      const initialDelay = 1000 + Math.random() * 3000;
      shopNowTimeout = setTimeout(showShopNow, initialDelay);
    }

    function updateCountdown() {
      const now = new Date().getTime();
      let targetDateTime = null;
      let newState = saleState;

      // Determine which countdown to show
      if (startDateTime && now < startDateTime.getTime()) {
        // Before sale starts - countdown to start
        targetDateTime = startDateTime;
        newState = 'before';
        // Update banner text
        if (bannerTextElement) {
          const textBefore = bannerTextElement.dataset.textBefore;
          if (textBefore) {
            bannerTextElement.textContent = textBefore;
          }
        }
      } else if (endDateTime && now < endDateTime.getTime()) {
        // During sale - countdown to end
        targetDateTime = endDateTime;
        newState = 'during';
        // Update banner text
        if (bannerTextElement) {
          const textDuring = bannerTextElement.dataset.textDuring;
          if (textDuring) {
            bannerTextElement.textContent = textDuring;
          }
        }
      } else {
        // Sale has ended
        if (timerElements.days) {
          timerElements.days.textContent = '00';
          timerElements.hours.textContent = '00';
          timerElements.minutes.textContent = '00';
          timerElements.seconds.textContent = '00';
        }
        
        // Reload page to show "Sale Ended" message
        setTimeout(function() {
          window.location.reload();
        }, 1000);
        return;
      }

      if (!targetDateTime) return;

      const distance = targetDateTime.getTime() - now;

      if (distance < 0) {
        // Transition between states - reload to update
        setTimeout(function() {
          window.location.reload();
        }, 1000);
        return;
      }

      // Calculate time units
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000)) / 1000);

      // Update display with animation
      function updateElement(element, value) {
        if (!element) return;
        const formattedValue = String(value).padStart(2, '0');
        if (element.textContent !== formattedValue) {
          element.classList.add('updated');
          element.textContent = formattedValue;
          setTimeout(function() {
            element.classList.remove('updated');
          }, 600);
        }
      }

      updateElement(timerElements.days, days);
      updateElement(timerElements.hours, hours);
      updateElement(timerElements.minutes, minutes);
      updateElement(timerElements.seconds, seconds);
    }

    // Initial update
    updateCountdown();

    // Update every second
    const countdownInterval = setInterval(updateCountdown, 1000);

    // Clean up on section unload
    document.addEventListener('shopify:section:unload', function(event) {
      if (event.detail.sectionId === sectionId) {
        clearInterval(countdownInterval);
        if (shopNowTimeout) {
          clearTimeout(shopNowTimeout);
        }
      }
    });
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', function() {
    const banners = document.querySelectorAll('[data-section-id]');
    banners.forEach(function(banner) {
      const sectionId = banner.dataset.sectionId;
      if (sectionId) {
        initCountdownBanner(sectionId);
      }
    });
  });

  // Initialize on section load (for theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    const sectionId = event.detail.sectionId;
    if (sectionId) {
      setTimeout(function() {
        initCountdownBanner(sectionId);
      }, 100);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-banner"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  function initCountdownBanner(sectionId) {
    const banner = document.getElementById('countdown-banner-' + sectionId);
    if (!banner) return;

    // Check if banner was dismissed (hidden via close button)
    const dismissedKey = 'countdown-banner-dismissed-' + sectionId;
    const isDismissed = localStorage.getItem(dismissedKey) === 'true';
    
    if (isDismissed) {
      banner.classList.remove('countdown-banner--visible');
      banner.classList.add('countdown-banner--hidden');
      return;
    }

    const startDate = banner.dataset.startDate;
    const startTime = banner.dataset.startTime || '00:00';
    const endDate = banner.dataset.endDate;
    const endTime = banner.dataset.endTime || '23:59';
    const saleState = banner.dataset.saleState;

    if (saleState === 'ended') {
      // Sale has ended, show ended message
      return;
    }

    // Parse dates and times
    let startDateTime = null;
    let endDateTime = null;

    if (startDate) {
      const [startYear, startMonth, startDay] = startDate.split('-');
      const [startHours, startMinutes] = startTime.split(':');
      startDateTime = new Date(startYear, startMonth - 1, startDay, parseInt(startHours), parseInt(startMinutes), 0, 0);
    }

    if (endDate) {
      const [endYear, endMonth, endDay] = endDate.split('-');
      const [endHours, endMinutes] = endTime.split(':');
      endDateTime = new Date(endYear, endMonth - 1, endDay, parseInt(endHours), parseInt(endMinutes), 0, 0);
    }

    const timerElements = {
      days: banner.querySelector('[data-days]'),
      hours: banner.querySelector('[data-hours]'),
      minutes: banner.querySelector('[data-minutes]'),
      seconds: banner.querySelector('[data-seconds]')
    };

    // Handle close button two-click behavior
    const closeButton = banner.querySelector('.countdown-banner__close');
    if (closeButton) {
      let clickCount = 0;
      const clickCountKey = 'countdown-banner-click-count-' + sectionId;
      
      // Restore click count from sessionStorage (resets on new session)
      const storedClickCount = sessionStorage.getItem(clickCountKey);
      if (storedClickCount) {
        clickCount = parseInt(storedClickCount, 10);
      }
      
      closeButton.addEventListener('click', function(e) {
        clickCount++;
        sessionStorage.setItem(clickCountKey, clickCount.toString());
        
        if (clickCount >= 2) {
          // Second click (or more) - hide the banner
          e.preventDefault();
          banner.classList.remove('countdown-banner--visible');
          banner.classList.add('countdown-banner--hidden');
          localStorage.setItem(dismissedKey, 'true');
          // Reset click count for next session
          sessionStorage.removeItem(clickCountKey);
        }
        // First click - allow normal navigation (do nothing, let link work)
      });
    }

    const bannerTextElement = banner.querySelector('.countdown-banner__text');
    const ctaContainer = banner.querySelector('.countdown-banner__cta-container');
    const timerElement = banner.querySelector('.countdown-banner__timer');
    const bannerContainer = banner.querySelector('.countdown-banner__container');
    const ctaLink = banner.querySelector('.countdown-banner__link');
    const hasCTALink = ctaLink !== null;
    
    // CTA text variants
    const ctaTexts = ['SHOP NOW', 'CLICK HERE', 'CLICK ME', 'SHOP HERE', 'BUY NOW', 'SHOP NOW'];
    
    // Active CTA elements
    const activeCTAs = [];
    let ctaTimeouts = [];
    
    // Get safe zones to avoid timer numbers
    function getTimerBounds() {
      if (!timerElement || !ctaContainer) return { left: 0, right: 0, top: 0, bottom: 0, width: 0, height: 0 };
      
      const timerRect = timerElement.getBoundingClientRect();
      const containerRect = ctaContainer.getBoundingClientRect();
      
      return {
        left: timerRect.left - containerRect.left - 25,
        right: timerRect.right - containerRect.left + 25,
        top: timerRect.top - containerRect.top - 20,
        bottom: timerRect.bottom - containerRect.top + 20,
        width: containerRect.width,
        height: containerRect.height
      };
    }
    
    // Check if position overlaps with timer
    function isPositionSafe(x, y, timerBounds) {
      // Check if position is outside timer area
      return !(x >= timerBounds.left && x <= timerBounds.right && 
               y >= timerBounds.top && y <= timerBounds.bottom);
    }
    
    // Create and show a random CTA
    function createRandomCTA() {
      if (!ctaContainer || !hasCTALink) return;
      
      const timerBounds = getTimerBounds();
      const containerWidth = timerBounds.width;
      const containerHeight = timerBounds.height;
      
      // Try to find a safe position (max 15 attempts)
      let x, y;
      let attempts = 0;
      do {
        // Random position across the entire banner width
        // Leave some padding on edges (accounting for container padding)
        x = 15 + Math.random() * (containerWidth - 130);
        y = 8 + Math.random() * (containerHeight - 35);
        attempts++;
      } while (!isPositionSafe(x, y, timerBounds) && attempts < 15);
      
      // If we couldn't find a safe spot, place it in a corner
      if (attempts >= 15) {
        const corners = [
          { x: 10, y: 8 },
          { x: containerWidth - 110, y: 8 },
          { x: 10, y: containerHeight - 30 },
          { x: containerWidth - 110, y: containerHeight - 30 }
        ];
        const corner = corners[Math.floor(Math.random() * corners.length)];
        x = corner.x;
        y = corner.y;
      }
      
      // Create CTA element
      const ctaOverlay = document.createElement('span');
      ctaOverlay.className = 'countdown-banner__cta-overlay';
      ctaOverlay.style.left = x + 'px';
      ctaOverlay.style.top = y + 'px';
      ctaOverlay.style.color = banner.style.color || '#ffffff';
      
      const ctaText = document.createElement('span');
      ctaText.className = 'countdown-banner__cta-text';
      ctaText.textContent = ctaTexts[Math.floor(Math.random() * ctaTexts.length)];
      ctaOverlay.appendChild(ctaText);
      
      ctaContainer.appendChild(ctaOverlay);
      activeCTAs.push(ctaOverlay);
      
      // Fade in
      setTimeout(function() {
        ctaOverlay.classList.add('fade-in');
        ctaOverlay.classList.add('visible');
      }, 10);
      
      // Random visible duration (2-5 seconds)
      const visibleDuration = 2000 + Math.random() * 3000;
      
      // Fade out and remove
      setTimeout(function() {
        ctaOverlay.classList.remove('fade-in');
        ctaOverlay.classList.add('fade-out');
        
        setTimeout(function() {
          if (ctaOverlay.parentNode) {
            ctaOverlay.parentNode.removeChild(ctaOverlay);
          }
          const index = activeCTAs.indexOf(ctaOverlay);
          if (index > -1) {
            activeCTAs.splice(index, 1);
          }
        }, 800);
      }, visibleDuration);
    }
    
    // Start the random CTA system
    function startCTASystem() {
      if (!hasCTALink || !ctaContainer) return;
      
      // Create first CTA after initial delay (1-3 seconds)
      const initialDelay = 1000 + Math.random() * 2000;
      let timeout = setTimeout(function() {
        createRandomCTA();
        scheduleNextCTA();
      }, initialDelay);
      ctaTimeouts.push(timeout);
    }
    
    // Schedule the next CTA appearance
    function scheduleNextCTA() {
      if (!hasCTALink || !ctaContainer) return;
      
      // Random delay before next CTA (2-6 seconds)
      const nextDelay = 2000 + Math.random() * 4000;
      
      // Limit to max 3 active CTAs at once
      if (activeCTAs.length < 3) {
        let timeout = setTimeout(function() {
          createRandomCTA();
          scheduleNextCTA();
        }, nextDelay);
        ctaTimeouts.push(timeout);
      } else {
        // Wait a bit longer if we have too many active
        let timeout = setTimeout(function() {
          scheduleNextCTA();
        }, 1000);
        ctaTimeouts.push(timeout);
      }
    }
    
    // Start the system
    startCTASystem();

    function updateCountdown() {
      const now = new Date().getTime();
      let targetDateTime = null;
      let newState = saleState;

      // Determine which countdown to show
      if (startDateTime && now < startDateTime.getTime()) {
        // Before sale starts - countdown to start
        targetDateTime = startDateTime;
        newState = 'before';
        // Update banner text
        if (bannerTextElement) {
          const textBefore = bannerTextElement.dataset.textBefore;
          if (textBefore) {
            bannerTextElement.textContent = textBefore;
          }
        }
      } else if (endDateTime && now < endDateTime.getTime()) {
        // During sale - countdown to end
        targetDateTime = endDateTime;
        newState = 'during';
        // Update banner text
        if (bannerTextElement) {
          const textDuring = bannerTextElement.dataset.textDuring;
          if (textDuring) {
            bannerTextElement.textContent = textDuring;
          }
        }
      } else {
        // Sale has ended
        if (timerElements.days) {
          timerElements.days.textContent = '00';
          timerElements.hours.textContent = '00';
          timerElements.minutes.textContent = '00';
          timerElements.seconds.textContent = '00';
        }
        
        // Reload page to show "Sale Ended" message
        setTimeout(function() {
          window.location.reload();
        }, 1000);
        return;
      }

      if (!targetDateTime) return;

      const distance = targetDateTime.getTime() - now;

      if (distance < 0) {
        // Transition between states - reload to update
        setTimeout(function() {
          window.location.reload();
        }, 1000);
        return;
      }

      // Calculate time units
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Update display with animation
      function updateElement(element, value) {
        if (!element) return;
        const formattedValue = String(value).padStart(2, '0');
        if (element.textContent !== formattedValue) {
          element.classList.add('updated');
          element.textContent = formattedValue;
          setTimeout(function() {
            element.classList.remove('updated');
          }, 600);
        }
      }

      updateElement(timerElements.days, days);
      updateElement(timerElements.hours, hours);
      updateElement(timerElements.minutes, minutes);
      updateElement(timerElements.seconds, seconds);
    }

    // Initial update
    updateCountdown();

    // Update every second
    const countdownInterval = setInterval(updateCountdown, 1000);

    // Clean up on section unload
    document.addEventListener('shopify:section:unload', function(event) {
      if (event.detail.sectionId === sectionId) {
        clearInterval(countdownInterval);
        // Clear all CTA timeouts
        ctaTimeouts.forEach(function(timeout) {
          clearTimeout(timeout);
        });
        ctaTimeouts = [];
        // Remove all active CTAs
        activeCTAs.forEach(function(cta) {
          if (cta.parentNode) {
            cta.parentNode.removeChild(cta);
          }
        });
        activeCTAs.length = 0;
      }
    });
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', function() {
    const banners = document.querySelectorAll('[data-section-id]');
    banners.forEach(function(banner) {
      const sectionId = banner.dataset.sectionId;
      if (sectionId) {
        initCountdownBanner(sectionId);
      }
    });
  });

  // Initialize on section load (for theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    const sectionId = event.detail.sectionId;
    if (sectionId) {
      setTimeout(function() {
        initCountdownBanner(sectionId);
      }, 100);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metafields-temp"]) return;
  try {
    
  const viewBtn = document.querySelector('.view-modal'),
    popup = document.querySelector('.popup'),
    close = popup.querySelector('.close'),
    field = popup.querySelector('.field'),
    input = field.querySelector('input'),
    copy = field.querySelector('button');

  viewBtn.onclick = () => {
    popup.classList.toggle('show');
  };
  close.onclick = () => {
    viewBtn.click();
  };

  copy.onclick = () => {
    input.select(); //select input value
    if (document.execCommand('copy')) {
      //if the selected text copy
      field.classList.add('active');
      copy.innerText = 'Copied';
      setTimeout(() => {
        window.getSelection().removeAllRanges(); //remove selection from document
        field.classList.remove('active');
        copy.innerText = 'Copy';
      }, 3000);
    }
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["summer-sale-countdown"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  // Convert an America/New_York wall-clock time to a real Date (hour 24 rolls to next day)
  function easternToDate(y, m, d, h, mi) {
    const guess = Date.UTC(y, m - 1, d, h, mi, 0);
    const fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York', hourCycle: 'h23',
      year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'
    });
    const parts = {};
    fmt.formatToParts(new Date(guess)).forEach(function(p) { parts[p.type] = Number(p.value); });
    const asEastern = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, 0);
    return new Date(guess + (guess - asEastern));
  }

  function initSummerSaleCountdown(sectionId) {
    const banner = document.getElementById('summer-sale-countdown-' + sectionId);
    if (!banner) return;

    const endDate = banner.dataset.endDate;
    const endTime = banner.dataset.endTime || '24:00';
    const saleState = banner.dataset.saleState;

    if (saleState === 'ended') {
      return;
    }

    // Parse end date/time as America/New_York wall-clock (handles EST/EDT)
    let endDateTime = null;
    if (endDate) {
      const [endYear, endMonth, endDay] = endDate.split('-').map(Number);
      const [endHours, endMinutes] = endTime.split(':').map(Number);
      endDateTime = easternToDate(endYear, endMonth, endDay, endHours || 0, endMinutes || 0);
    }

    const timerElements = {
      daysUnit: banner.querySelector('[data-days-unit]'),
      days: banner.querySelector('[data-days]'),
      hours: banner.querySelector('[data-hours]'),
      minutes: banner.querySelector('[data-minutes]'),
      seconds: banner.querySelector('[data-seconds]')
    };

    if (!endDateTime) return;

    let countdownInterval;

    function updateCountdown() {
      const now = new Date().getTime();
      const distance = endDateTime.getTime() - now;

      if (distance < 0) {
        // Sale has ended - hide the banner and stop polling
        banner.classList.add('summer-sale-countdown--hidden');
        banner.style.display = 'none';
        clearInterval(countdownInterval);
        return;
      }

      // Make sure banner is visible
      banner.classList.remove('summer-sale-countdown--hidden');
      banner.style.display = '';

      // Calculate time units
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Update display
      function updateElement(element, value) {
        if (!element) return;
        const formattedValue = String(value).padStart(2, '0');
        element.textContent = formattedValue;
      }

      if (timerElements.daysUnit) timerElements.daysUnit.hidden = days === 0;
      updateElement(timerElements.days, days);
      updateElement(timerElements.hours, hours);
      updateElement(timerElements.minutes, minutes);
      updateElement(timerElements.seconds, seconds);
    }

    // Initial update
    updateCountdown();

    // Update every second
    countdownInterval = setInterval(updateCountdown, 1000);

    // Clean up on section unload
    document.addEventListener('shopify:section:unload', function(event) {
      if (event.detail.sectionId === sectionId) {
        clearInterval(countdownInterval);
      }
    });
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', function() {
    const banners = document.querySelectorAll('[data-section-id]');
    banners.forEach(function(banner) {
      const sectionId = banner.dataset.sectionId;
      if (sectionId && banner.id.startsWith('summer-sale-countdown-')) {
        initSummerSaleCountdown(sectionId);
      }
    });
  });

  // Initialize on section load (for theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    const sectionId = event.detail.sectionId;
    if (sectionId) {
      const banner = document.getElementById('summer-sale-countdown-' + sectionId);
      if (banner) {
        setTimeout(function() {
          initSummerSaleCountdown(sectionId);
        }, 100);
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
